<template>
    <div>
        <!--
        <div><input style="margin-bottom:5px;border:none" type="file" @change="mobileFile" /></div>
        -->
        <div style="position:relative" :class="inDrag ? 'drop-file drop-file-hover' : 'drop-file'" @drop.prevent="drop" @dragenter.prevent @dragleave.prevent="dragLeave" @dragover.prevent="dragOver">
            <div v-if="!file">{{ text }}</div>
            <div v-else>{{ file.name }}</div>
            <input style="position:absolute;top:0;bottom:0;left:0;right:0;margin:0;opacity:0" type="file" :accept="pdfOnly ? '.pdf,application/pdf' : undefined" @change="mobileFile" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'DropFile',
    // pdfOnly: refuses anything but a .pdf (meeting item files)
    props: [ 'customText', 'imageOnly', 'pdfOnly' ],
    data() {
        return {
            file: null as any,
            inDrag: false,
            isMobile: false,
            text: 'Drop Single File'
        }
    },
    created() {
        if(navigator.maxTouchPoints || 'ontouchstart' in document.documentElement) {
            this.isMobile = true;
        }
        if(this.customText) {
            this.text = this.customText;
        }
    },
    methods: {
        drop(ev: any) {
            if(!this.allowed(ev.dataTransfer.files[0])) {
                this.inDrag = false;
                return;
            }
            this.file = ev.dataTransfer.files[0];
            this.inDrag = false;
            this.$forceUpdate();
            this.$emit('fileChange', this.file);
        },
        mobileFile(ev: any) {
            if(!this.allowed(ev.target.files[0])) {
                this.inDrag = false;
                return;
            }
            this.file = ev.target.files[0];
            this.$forceUpdate();
            this.$emit('fileChange', this.file);
        },
        allowed(doc: any) {
            if(!doc) {
                return false;
            }
            if(this.imageOnly && !this.checkIfImage(doc)) {
                return false;
            }
            if(this.pdfOnly && !/\.pdf$/i.test(doc.name)) {
                alert('Only PDF files can be added here');
                return false;
            }
            return true;
        },
        checkIfImage(doc: any) {
            if(!doc.name.toLowerCase().includes('.png') 
                && !doc.name.toLowerCase().includes('.jpg')
                && !doc.name.toLowerCase().includes('.jpeg')
                && !doc.name.toLowerCase().includes('.webp')
                && !doc.name.toLowerCase().includes('.gif')
                && !doc.name.toLowerCase().includes('.svg')
            ) {
                alert('File is not an image file');
                return false;
            } else {
                return true;
            }
        },
        dragOver() {
            this.inDrag = true;
        },
        dragLeave() {
            this.inDrag = false;
        },
    }
})
</script>